import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { emptyFn } from '../../utils/helper';
import { getContextValue, SegmentedControlContext } from './context';
var SegmentedControl = (function (_super) {
    __extends(SegmentedControl, _super);
    function SegmentedControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentActiveId: _this.props.defaultActiveId
        };
        _this.activeSegmentRef = React.createRef();
        _this.indicatorRef = React.createRef();
        _this.indicatorWidth = 0;
        _this.handleClick = function (e, id) {
            _this.props.onClick(e, id);
            if (id === _this.state.currentActiveId) {
                return;
            }
            _this.setState({ currentActiveId: id });
            _this.props.onChange(id);
        };
        _this.handleResize = function () {
            _this.updateIndicator(true);
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, children = _c.children, indicatorClassName = _c.indicatorClassName, indicatorStyle = _c.indicatorStyle, size = _c.size, activeSegmentClassName = _c.activeSegmentClassName, activeSegmentStyle = _c.activeSegmentStyle, segmentClassName = _c.segmentClassName, segmentStyle = _c.segmentStyle, testId = _c.testId, disabled = _c.disabled;
            var currentActiveId = _this.state.currentActiveId;
            var cls = classNames(prefixCls, className, prefixCls + "-" + size, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var indicatorCls = classNames(prefixCls + "-indicator", indicatorClassName, (_b = {},
                _b[prefixCls + "-indicator-visible"] = currentActiveId,
                _b));
            return (h("div", { className: cls, style: style, "data-testid": testId },
                h(SegmentedControlContext.Provider, { value: getContextValue({
                        activeId: currentActiveId,
                        activeSegmentRef: _this.activeSegmentRef,
                        onClick: _this.handleClick,
                        activeSegmentClassName: activeSegmentClassName,
                        activeSegmentStyle: activeSegmentStyle,
                        segmentClassName: segmentClassName,
                        segmentStyle: segmentStyle
                    }) }, children),
                h("div", { className: indicatorCls, style: indicatorStyle, ref: _this.indicatorRef })));
        };
        return _this;
    }
    SegmentedControl.getDerivedStateFromProps = function (props, state) {
        if (typeof props.activeId === 'string') {
            return { currentActiveId: props.activeId };
        }
        return null;
    };
    SegmentedControl.prototype.updateIndicator = function (skipAnimation) {
        if (skipAnimation === void 0) { skipAnimation = false; }
        var activeSegmentDom = this.activeSegmentRef.current;
        var indicatorDom = this.indicatorRef.current;
        if (!activeSegmentDom || !indicatorDom) {
            return;
        }
        var targetLeft = activeSegmentDom.offsetLeft, targetWidth = activeSegmentDom.offsetWidth;
        indicatorDom.style.transform = "translateX(" + targetLeft + "px)";
        if (this.indicatorWidth !== targetWidth) {
            indicatorDom.style.width = targetWidth + "px";
            this.indicatorWidth = targetWidth;
        }
        if (skipAnimation) {
            indicatorDom.style.transition = 'none';
            setTimeout(function () {
                indicatorDom.style.removeProperty('transition');
            }, 0);
        }
    };
    SegmentedControl.prototype.componentDidUpdate = function (prevProps, prevState) {
        var shouldSkipAnimation = Boolean(!prevState.currentActiveId && this.state.currentActiveId);
        this.updateIndicator(shouldSkipAnimation);
    };
    SegmentedControl.prototype.componentDidMount = function () {
        this.updateIndicator(true);
        window.addEventListener('resize', this.handleResize);
    };
    SegmentedControl.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    SegmentedControl.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return SegmentedControl;
}(React.Component));
export default SegmentedControl;
SegmentedControl.defaultProps = {
    prefixCls: 'dui-segmentedcontrol',
    defaultActiveId: '',
    onChange: emptyFn,
    onClick: emptyFn,
    size: 'small',
};
